import { NavLink, useLocation } from 'react-router-dom'
import { ChevronRightIcon, ChevronLeftIcon, HomeIcon, BarChartIcon, ExitIcon } from "@radix-ui/react-icons"
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import logo from '../assets/logo.svg'
import logoIcon from '../assets/logo-icon.svg'
import { useUser } from '@/hooks/useUser'

const navItems = [
  { name: 'Main', path: '/', icon: HomeIcon },
  { name: 'Reports', path: '/reports', icon: BarChartIcon },
]

interface SidebarProps {
  isCollapsed: boolean
  toggleSidebar: () => void
}

export function Sidebar({ isCollapsed, toggleSidebar }: Readonly<SidebarProps>) {
  const location = useLocation()
  const {logout} = useUser()

  return (
    <aside
      className={cn(
        "bg-brand text-white transition-all duration-300 ease-in-out flex flex-col min-h-screen",
        isCollapsed ? "w-16" : "w-64"
      )}
    >
      <div className="flex justify-between p-4">
        <img src={isCollapsed ? logoIcon : logo} className='w-22' alt="Logo"/>
        <Button variant="outline" size="icon" onClick={toggleSidebar}>
          {isCollapsed ? (
            <ChevronRightIcon className="h-4 w-4 text-black" />
          ) : (
            <ChevronLeftIcon className="h-4 w-4 text-black" />
          )}
        </Button>
      </div>
      <nav className="space-y-2 p-1 flex-grow">
        {navItems.map((item) => (
          <Button
            key={item.path}
            variant="ghost"
            className={cn(
              "w-full justify-start text-white hover:text-white hover:bg-brand-light",
              location.pathname === item.path && "bg-gray-500",
              isCollapsed && "justify-center"
            )}
            asChild
          >
            <NavLink to={item.path}>
              <item.icon className={cn("h-4 w-4", !isCollapsed && "mr-2")} />
              {!isCollapsed && <span>{item.name}</span>}
            </NavLink>
          </Button>
        ))}
      </nav>
      <div className="p-1 mt-auto">
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start text-white hover:text-white hover:bg-brand-light",
            isCollapsed && "justify-center"
          )}
          onClick={logout}
        >
          <ExitIcon className={cn("h-4 w-4", !isCollapsed && "mr-2")} />
          {!isCollapsed && <span>Logout</span>}
        </Button>
      </div>
    </aside>
  )
}